export const environment = {
  api_url: 'https://$customer_subdomain$.stage8store.rdsb.aws.tangoe.com/store/api/v1'
};